var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-select", {
    attrs: {
      options: _vm.unitsOptions,
      "stack-label": _vm.label,
      placeholder: "Unit",
      clearable: ""
    },
    on: { clear: _vm.clear, input: _vm.unitSelected },
    model: {
      value: _vm.selectedUnitId,
      callback: function($$v) {
        _vm.selectedUnitId = $$v
      },
      expression: "selectedUnitId"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }